export const GET_PRESIGNED_URL = gql`
    mutation GetSignedURL($input: FileUpload!) {
        getSecureUploadUrl(input: $input) {
            signedUrl
            backupSignedUrl
            tags
            viewableSignedUrl
        }
    }
`;
